import { array, object, string } from "yup";
import PageBlock from "@page-js/Pages/Page/Editor/scripts/pageBlock";

export default class Faq extends PageBlock {
  public getType(): string {
    return "Faq";
  }

  protected init(): any {
    return {
      props: {
        title: "FAQ",
        items: [],
        category: "all",
        categories: [{ id: "all", name: "전체" }],
      },
      attrs: {},
    };
  }

  public validateOrThrow(): Promise<any> {
    const schema = object().shape({
      props: object()
        .shape({
          categories: array()
            .of(
              object().shape({
                id: string().required(),
                name: string().max(32).required(),
              }),
            )
            .max(10)
            .label("카테고리 목록"),
          items: array()
            .of(
              object().shape({
                title: string().max(256).required().label("질문"),
                content: string().max(5000).required().label("답변"),
                category: string().required().label("카테고리"),
              }),
            )
            .label("FAQ 목록"),
        })
        .label("옵션"),
      attrs: object().required().label("속성"),
    });

    return schema.validate(this.toJSON(), { abortEarly: false });
  }
}
